export default __webpack_public_path__ + "static/visual_2-641a9cc6ee3d789bdcd04258b8938499.jpg";